<template>
  <div class="withdrawal">
    <div class="ok_withdrawal">
      <p class="ok_withdrawal_label">可提现收入</p>
      <div class="ok_withdrawal_input">
        <span>￥{{commission_price}}</span>
      </div>
    </div>

    <div class="type_withdrawal">
      <div class="van-cell">
        <div class="van-cell__title">
          <span>提现方式</span>
        </div>
        <div class="van-cell__value">
          <span>银行卡</span>
        </div>
      </div>

      <van-field v-model="name" type="text" label="姓名" placeholder="请输入姓名" />

      <van-field v-model="mobile" type="text" label="电话" placeholder="请输入手机号码" />

      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label">
          <span>选择银行</span>
        </div>
        <div class="van-cell__value">
          <div class="van-field__body" style="position:relative;" @click="showPopup">
            <span>{{choose_bankname?choose_bankname:'请选择银行'}}</span>
            <van-icon style="position:absolute;right:0;" name="arrow" size="14px" />
          </div>
        </div>
      </div>

      <van-field v-model="bankcard" type="text" label="银行卡号" placeholder="请输入银行卡号" />
    </div>

    <div style="font-size:.65rem;color:#45b9bc;padding:0 .5rem;">
      <!-- <p v-if="withdrawal_desc" class="flex_center" style="padding:.25rem 0;font-size:.6rem;"><van-icon name="warning-o" />{{withdrawal_desc}}</p> -->
      <div v-if="withdrawal_desc"><p  v-for="(desc,index) in withdrawal_desc" :key="index" class="flex_center" style="padding:.25rem 0;font-size:.6rem;"><van-icon name="warning-o" />{{desc}}</p></div>

      <p style="color:#F5643D;">提现手续费: <span>{{deduction_money}}</span></p>
    </div>

    <div class="button_box">
      <button class="withdrawal_btn" @click="apply_withdrawal">申请提现</button>
    </div>

    <van-popup v-model="show" position="bottom">
      <van-picker :columns="bankname" :default-index="2" @change="onChange" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "withdrawal",
  components: {},
  data() {
    return {
      commission_price: 0,
      bankname: [],
      tech_withdrawal_cost: 0,
      deduction_money: 0,
      name: "",
      mobile: "",
      bankcard: "",
      show: false,
      choose_bankname:"",
      withdrawal_desc:[],
    };
  },
  created() {
    this.tech_withdrawal_detail();
  },
  methods: {
    tech_withdrawal_detail() {
      this.axios({
        url: this.api.tech.tech_withdrawal_detail,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.commission_price = res.ok_price;
          this.bankname = res.bank_name;
          this.tech_withdrawal_cost = res.tech_withdrawal_cost;
          this.deduction_money = res.deduction_money;
          this.withdrawal_desc = res.tech_withdrawal_desc;
        }
      });
    },
    apply_withdrawal(){
      this.axios({
        url: this.api.tech.tech_withdrawal,
        data: {
          name:this.name,
          mobile:this.mobile,
          bankname:this.choose_bankname,
          bankcard:this.bankcard
          }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success",
            onClose: () => {
              this.$router.push("/tech_income");
            }
          });
        }else{
          this.$toast({
            message: res.message
          });
        }
      });
    },
    showPopup() {
      this.show = true;
    },
    onChange(picker, value, index) {
      // this.$toast(`当前值：${value}, 当前索引：${index}`);
      this.choose_bankname = value;
    }
  }
};
</script>
<style scoped>
select::-ms-expand {
  display: none;
}

/* --火狐、谷歌清除--*/

select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  padding-right: 14px;
  background-color: white;
  border: none;
  font-size: 14px;
}

option::-ms-expand {
  display: none;
}
option {
  border: none;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari 和 Chrome */
  appearance: none;
}

option:hover {
  color: #fff;
  background-color: #1e90ff;
}
.van-field__body {
  height: 24px;
  line-height: 24px;
}
.van-cell {
  font-size: 0.75rem;
}
.ok_withdrawal {
  background-color: white;
  padding: 1rem 0.75rem;
}
.ok_withdrawal_label {
  font-size: 0.6rem;
  color: #282828;
}
.ok_withdrawal_input {
  padding: 0.75rem 0;
  color: #45b9bc;
  font-size: 1.5rem;
  font-weight: bold;
}
.type_withdrawal {
  margin-top: 0.5rem;
}
.withdrawal_btn {
}
.button_box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  background-color: #45b9bc;
  color: white;
  font-size: 1rem;
  padding: 0.75rem 0;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/withdrawal.vue